<div class="card">
    <div class="card-header">
        <div class="d-flex align-items-center">
            <i class="fas fa-headset material-icon-fa card-title-icon me-2" aria-hidden="true"></i>
            <h2 class="dashboard-card-title">Open Service Requests</h2>
        </div>
        <p class="dashboard-card-subtitle mt-1">Form reviews and assistance requests.</p>
    </div>
    <div class="card-body p-3">
        @if(isLoading()){
        <div class="service-request-empty-state">
            <div class="spinner-border spinner-border-lg text-primary" role="status">
                <span class="visually-hidden">Loading Service Requests...</span>
            </div>
        </div>
        }
        @else if (serviceRequests().length) {
        @for (serviceRequest of serviceRequests(); track serviceRequest.serviceRequestId) {
        <div class="col-12 col-md-11 col-xl-9 mx-auto px-0">
            <div class="service-request-item">
                <div class="row align-items-center">

                    <!-- Col 1: Status + Last Modified -->
                    <div class="col-12 col-md-4 d-flex position-relative">
                        <div class="flex-grow-1 mt-2 mb-2">
                            <div class="chip-outline mb-1 mx-3 w-auto" [class]="getStatusClass(serviceRequest.status)">
                                {{ getStatusDisplay(serviceRequest.status) | titlecase }}
                            </div>
                            <div class="d-flex flex-wrap justify-content-center justify-content-md-between flex-md-column mx-3">
                                <div class="service-request-time mx-auto">
                                    <i [mdbTooltip]="'Last Updated'" class="fa-solid fa-stopwatch material-icon-fa"
                                        aria-hidden="true"></i>
                                    {{ formatServiceRequestDateTime(serviceRequest.modifiedDate ??
                                    serviceRequest.submittedDate) }}
                                </div>
                            </div>
                        </div>
                        <div class="vr vr-blurry ms-3 d-none d-md-block" style="height: auto; align-self: stretch;">
                        </div>
                    </div>

                    <!-- Mobile divider -->
                    <div class="col-12 d-md-none">
                        <hr class="hr my-2">
                    </div>

                    <!-- Col 2: SR Number + Description -->
                    <div class="col-12 col-md-7">
                        <div class="service-request-title text-center text-md-start mt-2">
                            {{ formatServiceRequestId(serviceRequest.serviceRequestId) }}
                        </div>
                        <div class="service-request-description text-center text-md-start d-md-block mb-3 mb-md-3"> {{
                            serviceRequest.description }}
                        </div>
                    </div>

                    <!-- Col 3: View Button -->
                    <div class="col-12 col-md-1">
                        <div class="d-flex justify-content-center justify-content-md-end">
                            <button type="button" [class]="getServiceRequestButtonClass()" [mdbTooltip]="'View'"
                                [routerLink]="['/service-request-details', serviceRequest.serviceRequestId]"
                                [attr.aria-label]="'View service request ' + formatServiceRequestId(serviceRequest.serviceRequestId)"
                                mdbRipple>
                                <i aria-hidden="true" class="fa-folder-open fa-regular fa-xl text-black"></i>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        }
        } @else {
        <div class="dashboard-empty-state d-flex flex-column justify-content-center align-items-center"
            style="min-height: 400px;">
            <i class="fa-solid fa-headset fa-3x material-icons" aria-hidden="true"></i>
            <div class="dashboard-empty-state-title">No Open Service Requests</div>
            <div class="dashboard-empty-state-message">
                You don't have any open service requests at the moment. When you submit a request for assistance, it
                will appear here.
            </div>
        </div>
        }
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col-1 col-md-2"></div>
            <div class="col-10 col-md-8">
                <div class="d-grid gap-2 text-center">
                    <button class="btn btn-lg btn-tertiary" aria-label="View Service Request History"
                        routerLink="/service-request-history" mdbRipple>
                        My Service Requests
                    </button>
                </div>
            </div>
            <div class="col-1 col-md-2"></div>
        </div>
    </div>
</div>
